import Controller from '../abstracts/Controller';

export default class DefaultController extends Controller {
  static get COMPONENTS() {
    return [];
  }
}
